/*绿色工程申报*/
import {apiRequest} from '../api.js'


//----------------------------------------------登录之后

/*获取已申报项目明细 - 申报单位 */
export function getApplyList_Apply(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgStcZjVy/selectForApply'
   apiRequest(config)
}

/*获取已申报项目明细 - 推荐单位 */
export function getApplyList_Recom(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgStcZjVy/selectForRecom'
   apiRequest(config)
}

//--------------------------------------申报基本数据


/*获取申报项目的基本信息*/
export function getApplyBasicInfo(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgStcZj/getApplyBasicInfo'
   apiRequest(config)
}

/*提交申报基本信息*/
export function postApplyBasicInfo(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaBasicMsgStcZj/postApplyBasicInfo'
   apiRequest(config)
}











